import { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

// Gold hairline ring that trails the pointer and snaps onto elements
// marked with [data-magnetic]. Pointer-events none, desktop only.
export const CursorRing = () => {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 340, damping: 30, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 340, damping: 30, mass: 0.5 });
  const [size, setSize] = useState(26);
  const [locked, setLocked] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    setEnabled(true);

    const move = (e) => {
      const target = e.target.closest?.('[data-magnetic], a, button');
      const magnetic = e.target.closest?.('[data-magnetic]');
      if (magnetic) {
        const r = magnetic.getBoundingClientRect();
        x.set(r.left + r.width / 2);
        y.set(r.top + r.height / 2);
        setSize(Math.max(r.width, r.height) + 16);
        setLocked(true);
      } else {
        x.set(e.clientX);
        y.set(e.clientY);
        setSize(target ? 46 : 26);
        setLocked(false);
      }
    };
    window.addEventListener('mousemove', move, { passive: true });
    return () => window.removeEventListener('mousemove', move);
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      aria-hidden="true"
      className="fixed top-0 left-0 z-[200] pointer-events-none hidden md:block"
      style={{ x: sx, y: sy }}
    >
      <motion.div
        animate={{ width: size, height: size, opacity: locked ? 0.9 : 0.55 }}
        transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
        style={{ translateX: '-50%', translateY: '-50%' }}
        className="border-[0.5px] border-gold"
      />
    </motion.div>
  );
};

export default CursorRing;
